import axiosInstance from "../../axios/index";

import {
  SET_ALL_QUESTIONS,
  SELECT_QUESTION,
  SET_INFINITE_QUESTIONS,
} from "../types/questionsTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";

export const setAllQuestions = (items, totalPages) => ({
  type: SET_ALL_QUESTIONS,
  payload: { items, totalPages },
});

export const setInfiniteQuestions = (items, totalPages) => ({
  type: SET_INFINITE_QUESTIONS,
  payload: { items, totalPages },
});

export const selectQuestion = (item) => ({
  type: SELECT_QUESTION,
  payload: item,
});

export const fetchAllQuestions = (lang, page, searchText) => {
  const language = lang.indexOf("fr") !== -1 ? "fr" : "en";
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.get(
        `/model/list_questions/${language}?page=${page}&search${
          searchText ? "=" + searchText : ""
        }`
      );
      dispatch(requestSucceeded());
      const items = res?.data;
      if (searchText && page === 1) {
        dispatch(setAllQuestions(items?.questions_list, items?.total_pages));
      } else {
        dispatch(
          setInfiniteQuestions(items?.questions_list, items?.total_pages)
        );
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const fetchQuestionById = (id) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.get(`/model/questions/${id}`);
      dispatch(requestSucceeded());
      const item = res?.data;
      dispatch(selectQuestion(item));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
